export function immutableResizableLayout<T extends object>(
  layout: readonly T[],
): readonly Readonly<T>[] {
  return Object.freeze(layout.map(item => Object.freeze({ ...item })))
}
